/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
window.Buyapowa = {};
window.Buyapowa.Controllers = {};
window.Buyapowa.Views = {};
window.Buyapowa.Helpers = {};

window.Buyapowa.initialize = function() {
  $("*[data-controller]").each(function() {
    const $el = $(this);

    const controllers = _.map($el.data("controller").split(","), c => $.trim(c));

    return (() => {
      const result = [];
      for (var controllerName of Array.from(controllers)) {
        var controller = new (window.Buyapowa.Controllers[controllerName])($el);
        result.push($el.data(controllerName, controller));
      }
      return result;
    })();
  });

  $("*[data-view]").each(function() {
    const $el = $(this);

    const views = _.map($el.data("view").split(","), v => $.trim(v));

    return (() => {
      const result = [];
      for (var viewName of Array.from(views)) {
        var view = new (window.Buyapowa.Views[viewName])($el);
        result.push($el.data(viewName, view));
      }
      return result;
    })();
  });

  return $("*[data-helper]").each(function() {
    const $el = $(this);

    const helpers = _.map($el.data("helper").split(","), h => $.trim(h));

    return (() => {
      const result = [];
      for (var helperName of Array.from(helpers)) {
        var helper = new (window.Buyapowa.Helpers[helperName])($el);
        result.push($el.data(helperName, helper));
      }
      return result;
    })();
  });
};
